import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { documentById } from '../strapi';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import img_base from '../img/image.png'

export default function NewsCard({ title, text, date, img, id, setNewsId, locale }) {
    const API_URL = process.env.REACT_APP_STRAPI_URL;
    let learnMore = locale === 'ru' ? 'Подробнее...' : 'Learn more...';
    const [imgSrc, setImgSrc] = React.useState(img ? API_URL + img : img_base);
    return (
        <Link to={"/news/" + id}>
        <Paper sx={{ maxWidth: 345, height: 410, m: 2 }}>
            <img
                style={{
                    objectFit: 'cover',
                    borderTopRightRadius: '4px',
                    borderTopLeftRadius: '4px'
                }}
                alt="news"
                height="140px"
                width="100%"
                src={imgSrc}
                onError={() => setImgSrc(img_base)}
            />

            <Stack sx={{ p: 3, height: '220px', justifyContent: 'space-between' }}>
                <Typography gutterBottom variant="body1" component="div">
                    {date}
                </Typography>
                <Typography gutterBottom variant="h5" component="div">
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', height: '90px', overflow: 'auto' }}>
                    {text}
                </Typography>
                <div>
                    <Button className='cardButton' size="small" variant='' >{learnMore}</Button>
                </div>
            </Stack>
        </Paper>
        </Link>
    );
}